module.exports = __webpack_public_path__ + "img/status-eveywhere.62f60526.png";